(function(){try{
  /* Case 31 - keeps per-stocking gift add-ons consistent with their stockings, on every page.
     Loaded site-wide from layout/theme.liquid because the cart can change anywhere: the cart page,
     SlideCart, GiftLab, a quantity box. Contract written by assets/saga-stocking-gift.js: a stocking
     line and its add-on lines share one hidden _saga_gift_id; add-on lines carry _saga_addon.

     Rules, applied after any cart change and once on load when the cart holds gift lines:
       - a wrap/card line always has the SAME quantity as its stocking line (one paid unit per stocking);
       - stocking removed -> its wrap/card lines are removed;
       - wrap or card line removed while the stocking still says it is wrapped / has a card -> the
         stocking is re-added without that property (Shopify cannot edit properties in place), so the
         order never promises wrapping or a card that was not paid for;
       - GiftLab's order-level "wrap my order" line (the same `wrap` variant, without _saga_addon) is
         removed and its cart offer hidden while any stocking is wrapped per stocking, so wrapping is
         never charged twice.
     Our own requests carry X-Saga-Sync so they do not trigger another pass. No customer-visible text. */
  var C=window.SagaGiftSync;
  if(!C||!window.fetch||!window.Promise)return;
  var RX=/[/]cart[/](add|change|update|clear)(\.js)?([?#]|$)/,HDR='X-Saga-Sync';
  var nativeFetch=window.fetch,busy=false,again=false,timer=null;
  function root(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function req(path,body){
    var h={'Accept':'application/json','Content-Type':'application/json'};h[HDR]='1';
    return nativeFetch.call(window,root()+path,{method:body?'POST':'GET',credentials:'same-origin',headers:h,body:body?JSON.stringify(body):undefined})
      .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();});
  }
  /* Case 38 - header cart badge. sections/header.liquid renders <span class="cart-link__count"> inside
     .cart-link__icon only when the cart is not empty, and nothing in theme.js ever updates it (the theme's
     own AJAX add only fires theme:cartchanged). Any cart change without a page load left it stale. This
     keeps that one existing element in step with /cart.js item_count (sum of line quantities, so paid
     wrapping and card lines count too). It never adds a second counter. */
  function paintCount(n){
    n=Math.max(0,parseInt(n,10)||0);
    document.querySelectorAll('.cart-link .cart-link__icon').forEach(function(icon){
      var el=icon.querySelector('.cart-link__count');
      if(n>0){
        if(!el){el=document.createElement('span');el.className='cart-link__count';icon.appendChild(el);}
        if(el.textContent!==String(n))el.textContent=String(n);
      }else if(el){el.parentNode.removeChild(el);}
    });
  }
  window.SagaCartCount=function(n){
    if(typeof n==='number'){paintCount(n);return Promise.resolve(n);}
    return req('cart.js').then(function(c){paintCount(c.item_count);return c.item_count;},function(){});
  };
  function flagged(init){
    try{var h=init&&init.headers;if(!h)return false;if(typeof h.get==='function')return !!h.get(HDR);return !!(h[HDR]||h[HDR.toLowerCase()]);}catch(e){return false;}
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(run,300);}
  window.fetch=function(input,init){
    var p=nativeFetch.apply(this,arguments);
    try{
      var url=typeof input==='string'?input:(input&&input.url)||'';
      if(RX.test(url)&&!flagged(init))p.then(schedule,function(){});
    }catch(e){}
    return p;
  };
  if(window.XMLHttpRequest){
    var xo=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,url){
      try{if(RX.test(String(url)))this.addEventListener('load',schedule);}catch(e){}
      return xo.apply(this,arguments);
    };
  }

  /* a stocking has a card when it names one: Case 35 keeps it in Card name; Case 31 carts kept the
     name in Greeting card itself, which is now only Yes/No */
  function hasCard(p){return !!(p['Card name']||(p['Greeting card']&&!/^(Yes|No)$/.test(p['Greeting card'])));}
  /* Case 56 - Gift Box name embroidery (assets/saga-giftbox.js): the box line lists its named items in
     _saga_names ("Blue bib name|Cream bib name"); each named item has one name line (_saga_addon=name,
     _saga_item = that key). Same rules as wrap/card, per item: a name line follows the box quantity; box
     removed -> its name lines are removed; a name line removed -> the box is re-added without that name, so
     the order never promises embroidery that was not paid for. Stocking carts have no name lines: unchanged. */
  function namesOf(p){return String(p._saga_names||'').split('|').filter(function(k){return !!k&&!!p[k];});}
  function plan(cart){
    var groups={},updates={},readd=[],count=0,wrapped=false,loose=[];
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{},gid=p._saga_gift_id;
      if(!gid){if(it.variant_id===C.wrap)loose.push(it);return;}
      var g=groups[gid]||(groups[gid]={s:[],wrap:[],card:[],name:[]});
      if(p._saga_addon==='wrap')g.wrap.push(it);else if(p._saga_addon==='card')g.card.push(it);else if(p._saga_addon==='name')g.name.push(it);else g.s.push(it);
    });
    function set(key,q){updates[key]=q;count++;}
    function follow(list,q){list.forEach(function(it,i){var want=i===0?q:0;if(it.quantity!==want)set(it.key,want);});}
    function sum(list){return list.reduce(function(a,it){return a+it.quantity;},0);}
    Object.keys(groups).forEach(function(gid){
      var g=groups[gid],S=sum(g.s);
      var wantWrap=g.s.some(function(it){return !!it.properties['Wrapping style'];});
      var wantCard=g.s.some(function(it){return hasCard(it.properties);});
      var wantNames={},byItem={},dropNames=[];
      g.s.forEach(function(it){namesOf(it.properties).forEach(function(k){wantNames[k]=true;});});
      g.name.forEach(function(it){var k=it.properties._saga_item||'';(byItem[k]=byItem[k]||[]).push(it);});
      if(S===0){follow(g.wrap,0);follow(g.card,0);follow(g.name,0);return;}
      var dropWrap=wantWrap&&sum(g.wrap)===0,dropCard=wantCard&&sum(g.card)===0;
      if(wantWrap&&!dropWrap)follow(g.wrap,S);else follow(g.wrap,0);
      if(wantCard&&!dropCard)follow(g.card,S);else follow(g.card,0);
      Object.keys(byItem).forEach(function(k){follow(byItem[k],wantNames[k]?S:0);});
      Object.keys(wantNames).forEach(function(k){if(!byItem[k]||sum(byItem[k])===0)dropNames.push(k);});
      if(wantWrap&&!dropWrap)wrapped=true;
      if(dropWrap||dropCard||dropNames.length){
        g.s.forEach(function(it){
          var np={};Object.keys(it.properties).forEach(function(k){np[k]=it.properties[k];});
          if(dropWrap){delete np['Wrapping style'];if('Gift wrapping' in np)np['Gift wrapping']='No';}
          if(dropCard){['Card name','Card no.','Card message','To','From','Greeting'].forEach(function(k){delete np[k];});if('Greeting card' in np)np['Greeting card']='No';}
          if(dropNames.length){
            dropNames.forEach(function(k){delete np[k];});
            var left=String(np._saga_names||'').split('|').filter(function(k){return !!k&&dropNames.indexOf(k)<0;});
            if(left.length)np._saga_names=left.join('|');else delete np._saga_names;
          }
          if(!np['Wrapping style']&&!hasCard(np)&&!namesOf(np).length){delete np._saga_gift_id;delete np.Gift;}
          set(it.key,0);
          readd.push({id:it.variant_id,quantity:it.quantity,properties:np});
        });
      }
    });
    if(wrapped)loose.forEach(function(it){set(it.key,0);});
    return {updates:updates,count:count,readd:readd,wrapped:wrapped};
  }
  function mark(on){try{document.documentElement.classList.toggle('saga-gift-wrapped',!!on);}catch(e){}}
  function onCartPage(){return !!document.querySelector('[data-section-type="cart-template"]');}
  window.SagaCartRefresh=function(open){
    try{if(typeof window.SLIDECART_UPDATE==='function')window.SLIDECART_UPDATE();}catch(e){}
    if(!open)return true;
    try{if(typeof window.SLIDECART_OPEN==='function'){window.SLIDECART_OPEN();return true;}}catch(e){}
    return false;
  };
  function run(){
    if(busy){again=true;return;}
    busy=true;
    req('cart.js').then(function(cart){
      var pl=plan(cart);
      mark(pl.wrapped);
      paintCount(cart.item_count);
      if(!pl.count)return false;
      /* removals and quantity fixes first, then re-add stripped stockings */
      return req('cart/update.js',{updates:pl.updates})
        .then(function(){return pl.readd.length?req('cart/add.js',{items:pl.readd}):null;})
        .then(function(){return req('cart.js');})
        .then(function(after){paintCount(after.item_count);mark(plan(after).wrapped);return true;});
    }).then(function(changed){
      busy=false;
      if(changed){
        if(onCartPage()){window.location.reload();return;}
        window.SagaCartRefresh(false);
      }
      if(again){again=false;schedule();}
    },function(){busy=false;});
  }
  /* always on load (badge from /cart.js; add-on fixes only when needed), after back/forward cache
     restores, and after the theme's own cart events */
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('pageshow',function(e){if(e.persisted)schedule();});
  document.documentElement.addEventListener('theme:cartchanged',schedule);
}catch(e){}})();
